import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ProfileMain from "../profile/ProfileMain";
import DefaultLoader from "../../components/loader/DefaultLoader";
import NextSeriesMain from "../profile/NextSeriesMain";
import RecentGameMain from "../profile/RecentGameMain";
import SeriesMain from "../series/SeriesMain";
import TrackmanChartMain from "../record/TrackmanChartMain";
import PitchLocationMain from "../record/PitchLocationMain";
import DamageChartMain from "../record/DamageChartMain";
import RecordTableMain from "../record/RecordTableMain";
import MovingChartMain from "../record/MovingChartMain";
import PitchDistributionChartMain from "../record/PitchDistributionChartMain";
import PitcherRecordTableMain from "../record/PitcherRecordTableMain";
import MovementProfile from "../profile/MovementProfileMain";
import LocationResultMain from "../record/LocationResultMain";

function MajorLeaguePitcherArea({profile}) {
    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Row>
            <Col md={3} className="digestDivBox" id="playerProfile">
                {
                    profile['teamId'] ?
                    <ProfileMain profile={profile} leagueType={4201}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="gameSchedule" className="digestDivBox">
                {
                    profile['teamId'] ?
                    <MovementProfile profile={profile}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="last7games" className="digestDivBox">
                {
                    profile['teamId'] ?
                    <RecentGameMain profile={profile} leagueType={4201}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
        </Row>
        {/* <Row>
            {
                profile['teamId'] ?
                <SeriesMain profile={profile}/> :
                <Col md={12}>
                    <div style={{height: '300px'}}>
                        <DefaultLoader />
                    </div>
                </Col>
            }
        </Row> */}
        <Row>
            <Col id="chartZone1" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                <div style={style}>
                {
                    profile['teamId'] ?
                    <TrackmanChartMain profile={profile} /> :
                    <DefaultLoader/>
                }
                </div>
            </Col>
            <Col id="chartZone2" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                <div style={{...style, ...{textAlign:'center'}}}>
                {
                    profile['teamId'] ?
                    <LocationResultMain profile={profile}/> :
                    <DefaultLoader/>
                }
                </div>
            </Col>
        </Row>
        <Row>
            <Col id="movingChartZone" className="digestDivBox" style={{position:'relative'}}>
                {
                    profile['teamId'] ?
                    <MovingChartMain profile={profile} /> :
                    <DefaultLoader/>
                }
            </Col>
        </Row>
        <Row>
            <Col id="damageMap" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <DamageChartMain profile={profile} /> :
                <DefaultLoader/>
            }
            </Col>
            <Col id="pitchLocation" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <PitchLocationMain profile={profile} /> :
                <DefaultLoader/>
            }
            </Col>
        </Row>
        <Row>
            <div id="tableContainer">
            {
                profile['teamId'] ?
                <PitcherRecordTableMain profile={profile}/> : 
                <div style={{height: '200px'}}>
                    <DefaultLoader/>
                </div>
            }
            </div>
        </Row>
        </>
    )
}

export default MajorLeaguePitcherArea;